import api from './api';

export async function getBalance() {
	const res = await api.get('/credits/balance');
	return res.data;
}

export async function getHistory(page = 1, limit = 10) {
	const res = await api.get('/credits/history', { params: { page, limit } });
	return res.data;
}

export async function purchaseCredits(pkg) {
	const res = await api.post('/credits/purchase', { package: pkg });
	return res.data;
}

export async function getReferralStats() {
	const res = await api.get('/credits/referrals');
	return res.data;
}


